import { ResourceType } from './resource-type';

/**
 * The resource type for BitstreamFormat
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */
export const BITSTREAM_FORMAT = new ResourceType('bitstreamformat');
